import { useFormikContext } from 'formik';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

/**
 *
 * @param {string}        children      - The content to be rendered next to the radio buttons
 * @param {Function}      handleSelect  - Callback when a radio button is selected
 * @param {string}        name          - key to use for form data
 * @param {Function}      openPopUp     - Callback to trigger opening modal when 'No' is selected
 * @returns {JSX.Element}               Radio buttons and content formatted together
 */
export default function RadioButton({ children, handleSelect, name, openPopUp }) {
  const form = useFormikContext();

  return (
    <>
      <div className="m-auto flex flex-col sm:m-0 sm:mr-auto sm:flex-row-reverse">
        <FormLabel className="ml-4 self-center">{children}</FormLabel>
        <RadioGroup
          value={form.values[name]}
          onChange={(e) => {
            form.setFieldValue(name, e.target.value);
            handleSelect(name, e.target.value);
            if (e.target.value === 'no') openPopUp(name);
          }}
          name={name}
        >
          <div className="m-auto flex flex-row">
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </div>
        </RadioGroup>
      </div>
    </>
  );
}
